import { gql } from '@apollo/client';

export const ADD_UPDATE_FINANCIAL_PRODUCT_WARRANTY = gql`
  mutation addOrUpdateFinancialProductWarranty($input: FinancialProductWarrantyEditItemInput) {
    addOrUpdateFinancialProductWarranty(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_FINANCIAL_PRODUCT_WARRANTY_FILTERS = gql`
  mutation updateFinancialProductWarrantyFilter($input: FinancialProductWarrantyFilterInput!) {
    updateFinancialProductWarrantyFilter(input: $input) {
      commandId
      correlationId
    }
  }
`;